<form (ngSubmit)="dialogRef.close(true)">
  <h1 data-testid="title-modal" mat-dialog-title>{{ data.title }}</h1>
  <div mat-dialog-content>
    <p data-testid="description-modal" [innerHTML]="data.description"></p>
    <div *ngIf="data.templateRef">
      <ng-container *ngTemplateOutlet="data.templateRef; context: data.templateRefInputs ?? {}"></ng-container>
    </div>
  </div>
  <div mat-dialog-actions>
    <button
      type="submit"
      data-testid="confirm-dialog-btn"
      mat-raised-button
      color="primary"
      [disabled]="data.disable && data.disable()">
      {{ data.confirmBtnText }}
    </button>
    <button
      [class.hidden]="!data.cancelBtnText"
      type="button"
      mat-raised-button
      data-testid="cancel-dialog-btn"
      mat-button
      (click)="dialogRef.close()">
      {{ data.cancelBtnText }}
    </button>
  </div>
</form>
